import { useId, type ReactNode } from 'react';
import * as s from './CoachMark.css';

interface CoachMarkProps {
  title?: string;
  children: ReactNode;
  onDismiss: () => void;
  dismissLabel?: string;
}

export function CoachMark({
  title: titleText,
  children,
  onDismiss,
  dismissLabel = '안내 닫기',
}: CoachMarkProps) {
  const titleId = useId();
  return (
    <div
      role="note"
      className={s.container}
      {...(titleText ? { 'aria-labelledby': titleId } : { 'aria-label': '안내' })}
    >
      <div className={s.content}>
        {titleText && (
          <strong id={titleId} className={s.title}>
            {titleText}
          </strong>
        )}
        <p className={s.body}>{children}</p>
      </div>
      <button
        type="button"
        className={s.dismissButton}
        onClick={onDismiss}
        aria-label={dismissLabel}
      >
        <svg
          aria-hidden="true"
          focusable="false"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
        >
          <path
            d="M3 3l8 8M11 3l-8 8"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </button>
    </div>
  );
}
